import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_BACKEND_CAROUSEL_COMPONENT_HORIZONTAL_SPACING_250318 } from "@faire/web-api--source/indigofair/settings/ENABLE_BACKEND_CAROUSEL_COMPONENT_HORIZONTAL_SPACING_250318";

export const useSettingBackendCarouselComponentHorizontalPadding =
  (): boolean =>
    useSetting(
      ENABLE_BACKEND_CAROUSEL_COMPONENT_HORIZONTAL_SPACING_250318,
      false
    );
